"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildCreateCustomerPayload = exports.buildCreateAccountPayload = exports.buildPasswordlessLoginPayload = exports.buildRequestPasswordlessLoginPayload = exports.buildUpdateAccountPasswordPayload = exports.buildResetPayload = exports.buildResetPayloadByEmail = exports.buildResetPayloadByDocument = exports.buildLoginPayload = exports.buildLoginByTokenPayload = exports.parseUsername = void 0;

var _errors = require("../errors");

var _validators = require("../validators");

var _helpers = require("../utils/helpers");

var _enums = require("../enums");

const parseUsername = async username => {
  try {
    return await Promise.any([(0, _validators.validateEmail)(username), (0, _validators.validateDocument)(username), (0, _validators.validatePhone)(username)]);
  } catch (err) {
    throw new _errors.PayloadError('Username is on an invalid format');
  }
};

exports.parseUsername = parseUsername;

const buildLoginPayload = async (username, password) => {
  return {
    [`grant_type`]: 'password',
    scope: 'legacy_access_token',
    username: await parseUsername(username),
    password
  };
};

exports.buildLoginPayload = buildLoginPayload;

const buildLoginByTokenPayload = token => {
  return {
    [`grant_type`]: 'magic_link_token',
    scope: 'legacy_access_token',
    [`magic_link_token`]: token
  };
};

exports.buildLoginByTokenPayload = buildLoginByTokenPayload;

const buildResetPayloadByEmail = (emailAddress, recoveryMethod, creating = false) => {
  const messageIdentifier = creating ? 'BRAZIL_ACQUISITION_PASSWORD_CREATE' : 'BRAZIL_ACQUISITION_PASSWORD_RESET';
  return {
    identifier: {
      type: 'EMAIL',
      emailAddress
    },
    recoveryMethod,
    messageIdentifier
  };
};

exports.buildResetPayloadByEmail = buildResetPayloadByEmail;

const buildResetPayloadByDocument = (document, recoveryMethod, creating = false) => {
  const messageIdentifier = creating ? 'BRAZIL_ACQUISITION_PASSWORD_CREATE' : 'BRAZIL_ACQUISITION_PASSWORD_RESET';
  return {
    identifier: {
      type: 'MAIN_DOCUMENT',
      documentCode: document,
      documentType: 'CPF'
    },
    recoveryMethod,
    messageIdentifier
  };
};

exports.buildResetPayloadByDocument = buildResetPayloadByDocument;

const buildResetPayload = async ({
  username,
  recoveryMethod,
  creating
}) => {
  const type = await (0, _helpers.getUsernameType)(username);

  if (type === _enums.USERNAME_TYPES.email) {
    return buildResetPayloadByEmail(username, recoveryMethod, creating);
  } else if (type === _enums.USERNAME_TYPES.cpf) {
    return buildResetPayloadByDocument(username, recoveryMethod, creating);
  }

  throw type;
};

exports.buildResetPayload = buildResetPayload;

const buildUpdateAccountPasswordPayload = (resetPasswordToken, password) => {
  return {
    resetPasswordToken,
    password
  };
};

exports.buildUpdateAccountPasswordPayload = buildUpdateAccountPasswordPayload;

const buildRequestPasswordlessLoginPayload = async (username, method) => {
  const parsedUsername = await parseUsername(username);

  if (method === _enums.PASSWORDLESS_LOGIN_TYPES.email) {
    return {
      emailAddress: parsedUsername,
      method
    };
  } else if (method === _enums.PASSWORDLESS_LOGIN_TYPES.cellphone) {
    return {
      method,
      phone: parsedUsername
    };
  }

  throw new Error('Passwordless login method is not valid.');
};

exports.buildRequestPasswordlessLoginPayload = buildRequestPasswordlessLoginPayload;

const buildPasswordlessLoginPayload = (code, verificationTicket) => {
  if (code && verificationTicket) {
    return {
      [`grant_type`]: 'creditas_passwordless_otp',
      [`verification_ticket`]: verificationTicket,
      scope: 'legacy_access_token',
      code
    };
  }

  throw new Error('Code or verification ticket is invalid.');
};

exports.buildPasswordlessLoginPayload = buildPasswordlessLoginPayload;

const buildCreateAccountPayload = async ({
  screenName,
  email,
  cpf
}) => {
  try {
    await Promise.all([(0, _validators.validateEmail)(email), (0, _validators.validateDocument)(cpf)]);
    return {
      screenName,
      authenticationClaims: [{
        type: 'EMAIL',
        emailAddress: email
      }, {
        type: 'MAIN_DOCUMENT',
        documentType: 'CPF',
        documentCode: cpf
      }]
    };
  } catch (err) {
    throw new _errors.PayloadError('Email or document is on an invalid format');
  }
};

exports.buildCreateAccountPayload = buildCreateAccountPayload;

const buildCreateCustomerPayload = async email => {
  try {
    return {
      emailAddress: await (0, _validators.validateEmail)(email)
    };
  } catch (err) {
    throw new _errors.PayloadError('Email is on an invalid format');
  }
};

exports.buildCreateCustomerPayload = buildCreateCustomerPayload;